module.exports = __webpack_public_path__ + "img/container-red.d2afa385.svg";